import React from "react";
import "./colorStripe.scss";
import colorsPride from  "../../assets/jsons/colors.json";

export const ColorStripe  = () => {
    const colors = colorsPride.colors;

    return(
        <div className={"color-stripe"}>
            {colors.map((color, index) => (
                <div
                    key={index}
                    style={{
                        backgroundColor: color,
                    }}
                    className={"color"}
                />
            ))}
        </div>
    )
}